import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import PublicNavBar from '../../components/PublicNavBar';
import PortalFooter from '../../components/PortalFooter';
import { contentAPI } from '../../services/api';

const DEFAULT = `Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung unserer Plattform Callcenter-Suche.

1. Leistungsbeschreibung
Unsere Plattform vermittelt zwischen Auftraggebern und Auftragnehmern. Wir fungieren als Vermittler und sind nicht selbst Vertragspartei der zwischen Auftraggebern und Auftragnehmern geschlossenen Verträge.

2. Verantwortung des Nutzers
Der Nutzer ist verantwortlich für die Richtigkeit der von ihm eingegebenen Daten. Verbotene Inhalte dürfen nicht hochgeladen oder verbreitet werden.

3. Zahlungsbedingungen
Die Bezahlung erfolgt nach Abschluss der Vermittlung über die auf der Plattform angegebenen Zahlungsmethoden. Alle Preise sind inkl. gesetzlicher Mehrwertsteuer.

4. Haftung
Wir haften nicht für Schäden, die durch die Nutzung der Plattform entstehen, es sei denn, diese sind durch Vorsatz oder grobe Fahrlässigkeit unsererseits verursacht.

5. Beendigung der Registrierung
Die Registrierung kann jederzeit widerrufen werden. Aktive Aufträge werden nach Beendigung noch abgeschlossen.`;

const TermsPage: React.FC = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    contentAPI.getAll()
      .then((res) => setContent(res.data.data?.content_terms || DEFAULT))
      .catch(() => setContent(DEFAULT))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
      <PublicNavBar />
      <Container maxWidth="lg" sx={{ py: 6, flex: 1 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 4 }}>
          Allgemeine Geschäftsbedingungen
        </Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 1.9 }}>
            {content}
          </Typography>
        )}
      </Container>
      <PortalFooter />
    </Box>
  );
};

export default TermsPage;
